import React from 'react'

interface ProgressBarProps {
  progress: number
  title?: string
  className?: string
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  title = 'Device Battery',
  className = ''
}) => {
  const clampedProgress = Math.max(0, Math.min(100, progress))
  const progressColor = clampedProgress > 20 ? 'bg-green-500' : 'bg-red-500'

  return (
    <div className={`py-1 ${className}`}>
      <div className="flex justify-between items-center mb-3">
        <div className="text-base font-semibold text-gray-700">{title}</div>
        <div className="text-base font-semibold text-gray-500">
          {clampedProgress}%
        </div>
      </div>
      <div className="w-full">
        <div className="h-2 bg-gray-200 rounded-sm overflow-hidden">
          <div
            className={`h-full rounded-sm transition-all duration-300 ${progressColor}`}
            style={{ width: `${clampedProgress}%` }}
          />
        </div>
      </div>
    </div>
  )
}

export default ProgressBar
